import { Page } from "@lib/pages/page";
import { SportTypeService } from "@api/services/sport-type/sport-type.service";
import { SportType } from "@lib/models/sport-type/sport-type";
import { HomeRoutes } from "@app/routes/home.routes";
import {LayoutService} from '@utils/services/layout/layout.service';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';

export abstract class VideoPage extends Page {
  public backLink =
    "/" +
    (SportTypeService.selectedSportType === SportType.Handball
      ? HomeRoutes.handball.relative.videos
      : HomeRoutes.videos.root);

  constructor() {
    super();
  }

  public get colorScheme(): ColorScheme {
    return LayoutService.colorScheme;
  }
}
